import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import { Image } from '@outdoor-voices/ui';
import { isMobile } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import PropTypes from 'prop-types';
import React from 'react';
import { useQuery } from 'urql';
import Card from './Card';
import Carousel from '../Carousel';
import CompareOverlay from '../CompareOverlay';
import ErrorBoundary from '../ErrorBoundary';
import EverGreen from '../EverGreen';
import { FABRIC_QUERY } from './queries';
import ProductListItem from '../ProductListItem';
import { parseMarkdown } from '../../apps/product/Tabs/utils';
import css from './Fabric.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Header = function Header(_ref) {
  var description = _ref.description,
      icon = _ref.icon,
      title = _ref.title;
  return /*#__PURE__*/_jsxs("div", {
    className: css.header,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.icon,
      dangerouslySetInnerHTML: {
        __html: icon.svg
      }
    }), /*#__PURE__*/_jsx("h1", {
      className: cc([css.title, css.center, css.large]),
      children: title
    }), description && /*#__PURE__*/_jsx("p", {
      className: css.description,
      children: description
    })]
  });
};

Header.defaultProps = {
  description: ''
};
Header.propTypes = {
  description: PropTypes.string,
  icon: PropTypes.shape().isRequired,
  title: PropTypes.string.isRequired
};

var CompareAttributes = function CompareAttributes(_ref2) {
  var attributes = _ref2.attributes,
      linkText = _ref2.linkText;
  return /*#__PURE__*/_jsx(CompareOverlay, {
    compareAttributes: attributes,
    linkText: linkText,
    small: true
  });
};

CompareAttributes.propTypes = {
  attributes: PropTypes.array.isRequired,
  linkText: PropTypes.string.isRequired
};

var Products = function Products(_ref3) {
  var collection = _ref3.collection,
      title = _ref3.title;
  var productSets = collection.productSets,
      absoluteUrl = collection.absoluteUrl;
  var items = productSets[0].carouselProducts;
  var products = items.edges.filter(function (_ref4) {
    var node = _ref4.node;
    return node.product !== null;
  });
  var carouselProducts = {
    edges: products
  };

  if (carouselProducts.edges.length <= 3) {
    return /*#__PURE__*/_jsx("div", {
      className: css.products,
      children: /*#__PURE__*/_jsx("ul", {
        className: css.list,
        children: carouselProducts.edges.map(function (_ref5) {
          var node = _ref5.node;
          return /*#__PURE__*/_jsx(React.Fragment, {
            children: node.product && /*#__PURE__*/_jsx("li", {
              className: css.product,
              children: /*#__PURE__*/_jsx(ErrorBoundary, {
                children: /*#__PURE__*/_jsx(ProductListItem, _objectSpread(_objectSpread({}, node), {}, {
                  displaySwatches: false,
                  faceout: {
                    id: node.colorway.id
                  },
                  isMobile: isMobile()
                }))
              })
            })
          }, node.id);
        })
      })
    });
  }

  return /*#__PURE__*/_jsx("div", {
    className: css.carousel,
    children: /*#__PURE__*/_jsx(Carousel, {
      componentType: "CAROUSEL_PRODUCT",
      carouselProducts: carouselProducts,
      cta: "Shop \u2014 ".concat(title),
      removeOuterMargins: true,
      url: absoluteUrl
    })
  });
};

Products.propTypes = {
  collection: PropTypes.shape().isRequired,
  title: PropTypes.string.isRequired
};

var SimilarFabrics = function SimilarFabrics(_ref6) {
  var fabrics = _ref6.fabrics;
  if (fabrics.length === 0) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: css.similarFabrics,
    children: [/*#__PURE__*/_jsx("h2", {
      className: cc([css.title, css.center, css.large]),
      children: "Similar Fabrics"
    }), /*#__PURE__*/_jsx("div", {
      className: css.items,
      children: fabrics.map(function (fabric) {
        return /*#__PURE__*/_createElement(Card, _objectSpread(_objectSpread({}, fabric), {}, {
          key: fabric.id,
          image: fabric.imageLanding
        }));
      })
    })]
  });
};

SimilarFabrics.propTypes = {
  fabrics: PropTypes.array.isRequired
};

var Fabric = function Fabric(_ref7) {
  var attributes = _ref7.attributes,
      collection = _ref7.collection,
      description = _ref7.description,
      evergreen = _ref7.evergreen,
      image = _ref7.image,
      imageLanding = _ref7.imageLanding,
      parent = _ref7.parent,
      siblingAttributes = _ref7.siblingAttributes,
      title = _ref7.title;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.fabric,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.image,
        children: /*#__PURE__*/_jsx(Image, {
          alt: image.alt,
          src: image.src,
          height: 630,
          width: 630,
          sizes: [315, 630],
          wrap: false
        })
      }), imageLanding && /*#__PURE__*/_jsx("div", {
        className: css.imageMobile,
        children: /*#__PURE__*/_jsx(Image, {
          alt: imageLanding.alt,
          src: imageLanding.src,
          height: 310,
          width: 550,
          sizes: [310, 620],
          wrap: false
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: css.content,
        children: [parent && /*#__PURE__*/_jsx("h3", {
          className: cc([css.title, css.medium]),
          children: title
        }), /*#__PURE__*/_jsx("p", {
          className: css.description,
          children: description
        }), evergreen && /*#__PURE__*/_jsx("div", {
          className: css.evergreen,
          children: /*#__PURE__*/_jsx(EverGreen, {})
        }), attributes && /*#__PURE__*/_jsxs("div", {
          className: css.heading,
          children: [/*#__PURE__*/_jsx("h4", {
            className: css.title,
            children: "Attributes:"
          }), /*#__PURE__*/_jsx("div", {
            className: css.attributes,
            dangerouslySetInnerHTML: {
              __html: attributes
            }
          })]
        }), siblingAttributes.length > 1 && /*#__PURE__*/_jsx(CompareAttributes, {
          attributes: siblingAttributes,
          linkText: "Compare All ".concat(parent)
        })]
      })]
    }), collection && /*#__PURE__*/_jsx(Products, {
      collection: collection,
      title: title
    })]
  });
};

Fabric.defaultProps = {
  attributes: '',
  collection: null,
  siblingAttributes: []
};
Fabric.propTypes = {
  attributes: PropTypes.string,
  collection: PropTypes.shape(),
  description: PropTypes.string.isRequired,
  evergreen: PropTypes.bool,
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }).isRequired,
  imageLanding: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }).isRequired,
  parent: PropTypes.string,
  siblingAttributes: PropTypes.array,
  title: PropTypes.string.isRequired
};

var Wrapper = function Wrapper(_ref8) {
  var id = _ref8.id;

  var _useQuery = useQuery({
    query: FABRIC_QUERY,
    variables: {
      id: id
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      fetching = _useQuery2$.fetching,
      error = _useQuery2$.error,
      data = _useQuery2$.data;

  if (fetching) {
    return /*#__PURE__*/_jsxs("div", {
      className: css.fetching,
      "aria-busy": "true",
      children: [/*#__PURE__*/_jsx("div", {
        className: css.fetchingIcon
      }), /*#__PURE__*/_jsx("div", {
        className: css.fetchingTitle
      }), /*#__PURE__*/_jsxs("div", {
        className: css.fetchingWrapper,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.fetchingImage
        }), /*#__PURE__*/_jsx("div", {
          className: css.fetchingContent
        })]
      })]
    });
  }

  if (error) {
    console.error(error);
    return /*#__PURE__*/_jsxs("div", {
      className: css.errorRoot,
      children: [/*#__PURE__*/_jsx("h2", {
        children: "Oops... something went wrong."
      }), /*#__PURE__*/_jsx("p", {
        className: css.details,
        children: error.message
      })]
    });
  }

  var _data$fabric = data.fabric,
      attributes = _data$fabric.attributes,
      children = _data$fabric.children,
      description = _data$fabric.description,
      icon = _data$fabric.icon,
      similarFabrics = _data$fabric.similarFabrics,
      title = _data$fabric.title;
  var hasChildren = children.length !== 0;

  if (!hasChildren) {
    return /*#__PURE__*/_jsxs("div", {
      className: cc([css.root, css.parent]),
      children: [/*#__PURE__*/_jsx(Header, {
        icon: icon,
        title: title
      }), /*#__PURE__*/_jsx(Fabric, _objectSpread(_objectSpread({}, data.fabric), {}, {
        attributes: parseMarkdown(attributes)
      })), /*#__PURE__*/_jsx(SimilarFabrics, {
        fabrics: similarFabrics
      })]
    });
  } else {
    var siblingAttributes = [];
    var childContent = children.map(function (child) {
      var attributes = parseMarkdown(child.attributes);

      if (attributes) {
        siblingAttributes.push({
          title: child.title,
          attributes: attributes
        });
      }

      return /*#__PURE__*/_createElement(Fabric, _objectSpread(_objectSpread({}, child), {}, {
        key: child.id,
        attributes: attributes,
        parent: title,
        siblingAttributes: siblingAttributes
      }));
    });
    return /*#__PURE__*/_jsxs("div", {
      className: cc([css.root, css.children]),
      children: [/*#__PURE__*/_jsx(Header, {
        description: description,
        hasChildren: true,
        icon: icon,
        title: title
      }), childContent, /*#__PURE__*/_jsx(SimilarFabrics, {
        fabrics: similarFabrics
      })]
    });
  }
};

Wrapper.propTypes = {
  id: PropTypes.string.isRequired
};
export default Wrapper;